/* Pagina prodotto V9 (EcomRules): galleria con frecce, scorrimento e zoom; tendine esclusive che si aprono anche dai link
   e dall'indirizzo (#valori-dose); quantità; finestre; barra fissa con prezzo x quantità. Da galleria-v8.js, contenuti-v8.js e
   app.js delle pagine di Codex. Il carrello è quello del tema: il modulo sta dentro <product-form>, i pulsanti della barra fissa
   e dell'acquisto finale lo inviano con form="er-pdp-form". */
(() => {
  const root = document.querySelector('.er-pdp--alto');
  if (!root) return;
  const $ = id => document.getElementById(id);

  /* Finestre (spedizione, zoom): clic fuori per chiudere, fuoco restituito al pulsante */
  let ultimo = null;
  const apri = (id, da) => { const d = $(id); if (!d || d.open) return; ultimo = da || document.activeElement; d.showModal(); };
  document.querySelectorAll('.er-pdp [data-er-apri]').forEach(b => b.addEventListener('click', () => apri(b.dataset.erApri, b)));
  document.querySelectorAll('.er-pdp dialog').forEach(d => {
    d.querySelectorAll('[data-er-chiudi]').forEach(b => b.addEventListener('click', () => d.close()));
    d.addEventListener('click', e => {
      if (e.target !== d) return;
      const r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
    });
    d.addEventListener('close', () => { if (ultimo?.isConnected) ultimo.focus({ preventScroll: true }); });
  });

  /* Galleria */
  const stage = $('gallery-stage');
  const slides = [...(stage?.querySelectorAll('.pdp-slide') || [])];
  const thumbs = [...root.querySelectorAll('.pdp-gallery-thumb')];
  const controls = root.querySelector('.pdp-gallery-controls');
  const zoom = $('zoom-button'), dialog = $('image-dialog'), zoomImg = $('zoom-image'), livello = $('gallery-zoom-level');
  let indice = 0;
  const stato = (i) => (controls?.dataset.stato || '').replace('{i}', i + 1).replace('{n}', slides.length).replace('{t}', thumbs[i]?.dataset.title || '');
  const scegli = (n, fuoco = false) => {
    if (!slides.length) return;
    indice = (n + slides.length) % slides.length;
    slides.forEach((s, i) => {
      const attiva = i === indice, img = s.querySelector('img');
      s.hidden = !attiva;
      if (attiva) { img.id = 'gallery-image'; img.loading = 'eager'; } else img.removeAttribute('id');
      thumbs[i]?.setAttribute('aria-pressed', String(attiva));
    });
    $('pdp-gallery-status').textContent = stato(indice);
    zoom?.setAttribute('aria-label', `${controls.dataset.zoomLabel}: ${thumbs[indice]?.dataset.title || ''}`);
    if (fuoco) thumbs[indice]?.focus({ preventScroll: true });
  };
  if (slides.length > 1) {
    const nav = root.querySelector('.v8-gallery-navigation');
    if (nav) nav.hidden = false;
    [[$('gallery-prev'), -1], [$('gallery-next'), 1]].forEach(([b, passo]) => {
      if (!b) return;
      b.hidden = false;
      b.addEventListener('click', e => { e.stopPropagation(); scegli(indice + passo); });
    });
  }
  thumbs.forEach((b, i) => b.addEventListener('click', () => scegli(i)));
  controls?.addEventListener('keydown', e => {
    const tasti = { ArrowRight: indice + 1, ArrowLeft: indice - 1, Home: 0, End: slides.length - 1 };
    if (e.key in tasti) { e.preventDefault(); scegli(tasti[e.key], true); }
  });
  zoom?.addEventListener('click', () => {
    const img = slides[indice]?.querySelector('img');
    if (!img || !dialog) return;
    zoomImg.src = img.dataset.zoom; zoomImg.alt = img.alt;
    $('pdp-zoom-title').textContent = `${controls.dataset.nome} · ${thumbs[indice]?.dataset.title || ''}`;
    dialog.classList.remove('is-zoomed');
    livello.textContent = livello.dataset.piu; livello.setAttribute('aria-pressed', 'false');
    const sc = dialog.querySelector('.pdp-zoom-scroll'); sc.scrollTop = 0; sc.scrollLeft = 0;
    apri('image-dialog', zoom);
  });
  livello?.addEventListener('click', () => {
    const grande = dialog.classList.toggle('is-zoomed');
    livello.textContent = grande ? livello.dataset.adatta : livello.dataset.piu;
    livello.setAttribute('aria-pressed', String(grande));
  });
  let tocco = null, scorso = false;
  stage?.addEventListener('touchstart', e => { const t = e.changedTouches[0]; tocco = { x: t.clientX, y: t.clientY }; scorso = false; }, { passive: true });
  stage?.addEventListener('touchend', e => {
    if (!tocco) return;
    const t = e.changedTouches[0], dx = t.clientX - tocco.x, dy = t.clientY - tocco.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) { scorso = true; scegli(indice + (dx < 0 ? 1 : -1)); setTimeout(() => { scorso = false; }, 400); }
    tocco = null;
  }, { passive: true });
  stage?.addEventListener('click', () => { if (!scorso) zoom?.click(); });

  /* Tendine: una sola aperta per gruppo (details name), anche nei browser senza il supporto nativo */
  const chiudiAltre = d => {
    if (!d.name) return;
    document.querySelectorAll(`.er-pdp details[name="${d.name}"]`).forEach(x => { if (x !== d) x.open = false; });
  };
  document.querySelectorAll('.er-pdp details[name]').forEach(d => {
    const s = d.querySelector(':scope > summary');
    s?.addEventListener('click', e => {
      e.preventDefault();
      const apre = !d.open;
      if (apre) chiudiAltre(d);
      d.open = apre;
      if (apre) requestAnimationFrame(() => {
        const r = s.getBoundingClientRect(), barra = $('sticky-buy');
        const riservato = barra?.classList.contains('visible') ? barra.offsetHeight : 0;
        if (r.top < 28 || r.bottom > innerHeight - riservato - 16) s.scrollIntoView({ block: 'start', behavior: 'instant' });
      });
    });
    d.addEventListener('toggle', () => { if (d.open) chiudiAltre(d); });
  });
  /* Link a una tendina (#valori-dose, #uso-avvertenze, #utilizzo…): apre lei e le tendine che la contengono */
  const apriTendina = (id, fuoco = false) => {
    const t = id && document.getElementById(id);
    if (!t || !t.closest('.v8-product-details')) return false;
    for (let n = t; n; n = n.parentElement) if (n instanceof HTMLDetailsElement) { chiudiAltre(n); n.open = true; }
    requestAnimationFrame(() => {
      t.scrollIntoView({ block: 'start', behavior: 'instant' });
      if (fuoco) t.querySelector('summary')?.focus({ preventScroll: true });
    });
    return true;
  };
  document.addEventListener('click', e => {
    const a = e.target.closest('.er-pdp a[href^="#"]');
    if (!a || !apriTendina(a.getAttribute('href').slice(1), true)) return;
    e.preventDefault();
    history.pushState(null, '', a.getAttribute('href'));
  });
  window.addEventListener('hashchange', () => apriTendina(location.hash.slice(1)));
  if (location.hash) apriTendina(location.hash.slice(1));

  /* Quantità (campo vero del modulo) e prezzo nella barra fissa */
  const q = $('quantity-value'), meno = $('quantity-minus'), piu = $('quantity-plus');
  const barra = $('sticky-buy'), prezzoBarra = $('sticky-price');
  // ponytail: prezzo x quantità riscrivendo le cifre del prezzo già formattato da Shopify; niente separatore delle migliaia
  const conQuantita = n => {
    if (!barra || !prezzoBarra) return;
    const testo = barra.dataset.prezzoTesto, cent = Number(barra.dataset.prezzo) * n;
    const m = testo.match(/\d+(?:[.,']\d{3})*([.,])\d{2}/);
    prezzoBarra.textContent = m ? testo.replace(m[0], (cent / 100).toFixed(2).replace('.', m[1])) : testo;
  };
  const quantita = v => {
    const n = Math.min(99, Math.max(1, parseInt(v, 10) || 1));
    q.value = n; meno.disabled = n === 1; piu.disabled = n === 99;
    conQuantita(n);
  };
  if (q) {
    [meno, piu].forEach(b => b?.addEventListener('click', () => quantita(+q.value + +b.dataset.erQty)));
    q.addEventListener('change', () => quantita(q.value));
  }

  /* Dopo l'aggiunta il tema emette "add-to-cart": si apre il suo carrello laterale */
  root.querySelector('product-form')?.addEventListener('add-to-cart', () => $('site-cart-sidebar')?.show?.());

  /* Barra fissa: compare solo dopo aver superato il pulsante principale */
  const bottone = $('add-to-cart');
  if (barra && bottone) {
    const aggiorna = () => {
      const vedi = bottone.getBoundingClientRect().bottom < 0;
      barra.classList.toggle('visible', vedi);
      barra.inert = !vedi;
    };
    new IntersectionObserver(aggiorna, { threshold: [0, 1] }).observe(bottone);
    addEventListener('scroll', aggiorna, { passive: true });
    addEventListener('resize', aggiorna, { passive: true });
  }
})();
